import React, { Component } from 'react';
import { Link } from 'react-router-dom';
class Movie_item extends Component {
    render() {
        return (
            <div className="card movie_card mb-3">
                <img src={this.props.medium_cover_image !== '404' ? this.props.medium_cover_image : process.env.PUBLIC_URL + '/Thamnail.png'} className="card-img-top img-fluid p-1 rounded" alt="Thumbnail" />
                <div className="card-body p-2">
                    <Link to={`/detail/movies/${this.props.id}`}><i className="bi bi-play-fill play_button text-white" ></i></Link>
                    <h6 className="card-title mt-2 text-truncate">{this.props.title}</h6>
                    <div className="clearfix">
                        <span className="movie_info ">{this.props.year}</span>
                        <span className="movie_info float-end"><i className="bi bi-star-fill text-warning"></i> {this.props.rating}</span>
                    </div>
                </div>
            </div>
        );
    }
}
export default Movie_item;